import { render, staticRenderFns } from "./SmsCredits.vue?vue&type=template&id=2d75184b&scoped=true&"
import script from "./SmsCredits.vue?vue&type=script&lang=js&"
export * from "./SmsCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d75184b",
  null
  
)

export default component.exports